export const products = [
  {
    id: 'egyptian-potatoes',
    name: 'Egyptian Potatoes',
    category: 'Vegetables',
    image: '/potato/p1.jpeg',
    gallery: [
      '/potato/p2.jpeg',
      '/potato/p1.jpeg' // قمت بإضافة الصورة الأولى في المعرض أيضاً ليكون هناك تنوع
    ],
    description: 'High quantities of premium quality Egyptian potatoes, serving both table and processing businesses worldwide. Renowned for taste and texture.',
    specifications: {
      variety: 'Spunta, Lady Rosetta, Hermes',
      size: '40mm - 70mm+ (Calibrated)',
      freshness: 'Fresh Harvest / Cold Storage',
      season: 'January - June',
      shelfLife: '2-4 months cold storage',
      packaging: '10kg, 25kg Mesh Bags, Jumbo Bags'
    }
  },
  {
    id: 'spring-onion',
    name: 'Spring Onion',
    category: 'Vegetables',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20vibrant%20green%20spring%20onions%20scallions%20bunch%20with%20white%20bulbs%20on%20clean%20white%20background%20professional%20studio%20food%20photography%20high%20resolution%20crisp%20detail%20export%20quality%20vegetables&width=600&height=400&seq=701&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Fresh%20spring%20onions%20scallions%20bunch%20on%20wooden%20cutting%20board%20professional%20food%20photography%20natural%20lighting%20green%20vegetables%20simple%20background&width=800&height=600&seq=602&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Spring%20onion%20farm%20in%20Egypt%20rows%20of%20green%20plants%20agricultural%20landscape%20professional%20photography%20sunny%20day&width=800&height=600&seq=603&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Spring%20onions%20bunched%20and%20packed%20ready%20for%20export%20professional%20product%20photography%20clean%20background&width=800&height=600&seq=604&orientation=landscape'
    ],
    description: 'Fresh Egyptian spring onions with crisp white bulbs and vibrant green tops. Perfect for Asian cuisines and fresh garnishing.',
    specifications: {
      variety: 'White Lisbon, Evergreen',
      size: '20-30cm length',
      freshness: 'Harvested daily',
      season: 'Year-round',
      shelfLife: '7-14 days cold storage',
      packaging: 'Bunches, 5kg cartons'
    }
  },
  {
    id: 'red-onion',
    name: 'Red Onion',
    category: 'Vegetables',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20red%20onions%20whole%20on%20white%20marble%20surface%20professional%20food%20photography%20purple%20red%20color%20simple%20clean%20background%20high%20quality%20export%20grade%20vegetables&width=600&height=400&seq=605&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Fresh%20red%20onions%20whole%20and%20sliced%20on%20dark%20slate%20background%20professional%20food%20photography%20dramatic%20lighting%20purple%20color&width=800&height=600&seq=606&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Red%20onion%20farm%20in%20Egypt%20rows%20of%20plants%20agricultural%20landscape%20professional%20photography%20sunny%20day&width=800&height=600&seq=607&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Red%20onions%20in%20mesh%20bags%20ready%20for%20export%20warehouse%20packaging%20professional%20product%20photography&width=800&height=600&seq=608&orientation=landscape'
    ],
    description: 'Egyptian red onions offer a milder, sweeter flavor perfect for salads and fresh applications. Beautiful purple-red color adds visual appeal.',
    specifications: {
      variety: 'Red Creole, Tropea',
      size: '40-70mm diameter',
      dryMatter: '10-13%',
      season: 'Year-round',
      shelfLife: '2-4 months dry storage',
      packaging: '25kg mesh bags, 10kg cartons'
    }
  },
  {
    id: 'golden-onions',
    name: 'Golden Onions',
    category: 'Vegetables',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20golden%20yellow%20onions%20on%20white%20marble%20surface%20professional%20food%20photography%20clean%20minimal%20style%20simple%20background%20high%20quality%20export%20grade%20vegetables&width=600&height=400&seq=609&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Fresh%20yellow%20onions%20on%20burlap%20sack%20rustic%20wooden%20background%20professional%20food%20photography%20natural%20lighting%20clean%20style&width=800&height=600&seq=610&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Onion%20farm%20in%20Egypt%20harvesting%20scene%20workers%20collecting%20onions%20agricultural%20landscape%20professional%20photography&width=800&height=600&seq=611&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Onions%20in%20mesh%20bags%20ready%20for%20export%20warehouse%20packaging%20professional%20product%20photography&width=800&height=600&seq=612&orientation=landscape'
    ],
    description: 'Egyptian golden onions are known for their pungent flavor and excellent storage qualities. A staple ingredient for cuisines worldwide.',
    specifications: {
      variety: 'Giza Red, Texas Early',
      size: '40-80mm diameter',
      dryMatter: '12-15%',
      season: 'Year-round',
      shelfLife: '3-6 months dry storage',
      packaging: '25kg mesh bags, big bags'
    }
  },
  {
    id: 'sweet-potatoes',
    name: 'Egyptian Sweet Potatoes',
    category: 'Vegetables',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20orange%20sweet%20potatoes%20on%20white%20marble%20surface%20professional%20food%20photography%20clean%20minimal%20style%20simple%20background%20high%20quality%20export%20grade%20vegetables&width=600&height=400&seq=613&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Fresh%20orange%20sweet%20potatoes%20whole%20and%20sliced%20on%20wooden%20cutting%20board%20professional%20food%20photography%20warm%20natural%20lighting&width=800&height=600&seq=614&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Sweet%20potato%20farm%20in%20Egypt%20harvesting%20scene%20orange%20tubers%20in%20soil%20agricultural%20landscape%20professional%20photography&width=800&height=600&seq=615&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Sweet%20potatoes%20in%20wooden%20crates%20ready%20for%20export%20warehouse%20professional%20product%20photography%20clean%20background&width=800&height=600&seq=616&orientation=landscape'
    ],
    description: 'Egyptian sweet potatoes offer a naturally sweet flavor and creamy texture. Rich in vitamins and perfect for healthy food applications.',
    specifications: {
      variety: 'Beauregard, Covington, Orleans',
      size: '150-400g per piece',
      dryMatter: '25-30%',
      season: 'September - March',
      shelfLife: '2-4 months cold storage',
      packaging: '6kg cartons, mesh bags'
    }
  },
  {
    id: 'carrots',
    name: 'Egyptian Carrots',
    category: 'Vegetables',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20orange%20carrots%20with%20green%20tops%20on%20white%20marble%20surface%20professional%20food%20photography%20clean%20minimal%20style%20simple%20background%20high%20quality%20export%20grade%20vegetables&width=600&height=400&seq=617&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Fresh%20carrots%20on%20wooden%20cutting%20board%20professional%20food%20photography%20natural%20lighting%20orange%20vegetables&width=800&height=600&seq=618&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Carrot%20farm%20in%20Egypt%20rows%20of%20plants%20agricultural%20landscape%20professional%20photography%20sunny%20day&width=800&height=600&seq=619&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Carrots%20in%20plastic%20bags%20ready%20for%20export%20warehouse%20packaging%20professional%20product%20photography&width=800&height=600&seq=620&orientation=landscape'
    ],
    description: 'Egyptian carrots are known for their sweet taste and crisp texture. Rich in beta-carotene and perfect for fresh consumption or processing.',
    specifications: {
      variety: 'Nantes, Chantenay, Imperator',
      size: '15-25cm length',
      color: 'Deep orange',
      season: 'Year-round',
      shelfLife: '2-3 months cold storage',
      packaging: '10kg cartons, mesh bags'
    }
  },
  {
    id: 'lemons',
    name: 'Egyptian Lemons',
    category: 'Vegetables',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20yellow%20lemons%20with%20green%20leaves%20on%20white%20marble%20surface%20professional%20food%20photography%20citrus%20fruits%20clean%20minimal%20style%20simple%20background%20high%20quality%20export%20grade&width=600&height=400&seq=621&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Fresh%20yellow%20lemons%20with%20green%20leaves%20on%20white%20background%20professional%20food%20photography%20citrus%20fruits%20clean%20minimal%20style%20high%20quality%20export%20grade&width=800&height=600&seq=622&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Lemon%20trees%20in%20Egyptian%20orchard%20with%20ripe%20yellow%20lemons%20sunny%20day%20agricultural%20landscape%20professional%20photography&width=800&height=600&seq=623&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Sliced%20lemons%20showing%20fresh%20juicy%20interior%20on%20wooden%20cutting%20board%20professional%20food%20photography%20bright%20natural%20lighting&width=800&height=600&seq=624&orientation=landscape'
    ],
    description: 'Egyptian lemons are renowned for their high juice content and aromatic zest. Perfect for culinary applications and beverage production.',
    specifications: {
      variety: 'Eureka, Lisbon, Adalia',
      size: '50-70mm diameter',
      juiceContent: '30-35%',
      season: 'Year-round',
      shelfLife: '3-4 weeks cold storage',
      packaging: '10kg cartons, bulk bins'
    }
  },
  {
    id: 'garlic',
    name: 'Garlic',
    category: 'Vegetables',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20white%20garlic%20bulbs%20on%20white%20marble%20surface%20professional%20food%20photography%20clean%20minimal%20style%20simple%20background%20high%20quality%20export%20grade%20vegetables&width=600&height=400&seq=625&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Fresh%20white%20garlic%20bulbs%20on%20dark%20slate%20background%20professional%20food%20photography%20dramatic%20lighting%20clean%20minimal%20style&width=800&height=600&seq=626&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Garlic%20farm%20in%20Egypt%20rows%20of%20garlic%20plants%20agricultural%20landscape%20professional%20photography%20sunny%20day&width=800&height=600&seq=627&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Garlic%20bulbs%20in%20mesh%20bags%20ready%20for%20export%20warehouse%20packaging%20professional%20product%20photography&width=800&height=600&seq=628&orientation=landscape'
    ],
    description: 'Egyptian garlic is prized for its strong flavor and excellent storage qualities. Our garlic meets strict quality standards for international markets.',
    specifications: {
      variety: 'Egyptian White, Red Garlic',
      size: '45-65mm diameter',
      dryMatter: '35-40%',
      season: 'April - August',
      shelfLife: '6-8 months dry storage',
      packaging: '10kg cartons, mesh bags'
    }
  },
  {
    id: 'pomegranate',
    name: 'Pomegranate',
    category: 'Fruits',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20whole%20pomegranates%20with%20ruby%20red%20color%20on%20white%20marble%20surface%20professional%20food%20photography%20clean%20minimal%20style%20simple%20background%20high%20quality%20export%20grade%20fruits&width=600&height=400&seq=629&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Fresh%20whole%20pomegranates%20with%20one%20cut%20open%20showing%20ruby%20red%20seeds%20on%20dark%20slate%20background%20professional%20food%20photography%20dramatic%20lighting&width=800&height=600&seq=630&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Pomegranate%20orchard%20in%20Egypt%20with%20ripe%20fruits%20on%20trees%20golden%20hour%20sunlight%20agricultural%20landscape%20professional%20photography&width=800&height=600&seq=631&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Pomegranate%20seeds%20arils%20in%20white%20bowl%20fresh%20ruby%20red%20color%20professional%20food%20photography%20clean%20minimal%20background&width=800&height=600&seq=632&orientation=landscape'
    ],
    description: 'Egyptian pomegranates are prized for their deep ruby-red arils and exceptional sweetness. Rich in antioxidants and perfect for fresh consumption or juice production.',
    specifications: {
      variety: 'Wonderful, Manfalouty, Nab El-Gamal',
      size: '250-500g per fruit',
      brix: '15-18°',
      season: 'September - February',
      shelfLife: '2-3 months cold storage',
      packaging: '3.5kg cartons, single layer'
    }
  },
  {
    id: 'oranges',
    name: 'Egyptian Oranges',
    category: 'Fruits',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20Egyptian%20navel%20oranges%20on%20white%20marble%20surface%20with%20green%20leaves%20natural%20lighting%20professional%20food%20photography%20clean%20minimal%20background%20high%20quality%20export%20grade%20citrus%20fruits&width=600&height=400&seq=633&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Fresh%20Egyptian%20navel%20oranges%20arranged%20beautifully%20on%20white%20marble%20surface%20with%20green%20leaves%20natural%20lighting%20professional%20food%20photography%20clean%20minimal%20background%20high%20quality%20export%20grade%20citrus%20fruits&width=800&height=600&seq=634&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Orange%20orchard%20in%20Egypt%20with%20ripe%20oranges%20hanging%20from%20trees%20golden%20sunlight%20agricultural%20farm%20landscape%20professional%20photography%20lush%20green%20foliage&width=800&height=600&seq=635&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Wooden%20crates%20filled%20with%20fresh%20oranges%20ready%20for%20export%20warehouse%20packaging%20professional%20agricultural%20product%20photography%20clean%20background&width=800&height=600&seq=636&orientation=landscape'
    ],
    description: 'Premium Egyptian navel oranges known for their exceptional sweetness and juiciness. Our citrus fruits are carefully selected from the finest orchards in Egypt.',
    specifications: {
      variety: 'Navel, Valencia, Blood Orange',
      size: '60-88mm diameter',
      brix: '11-14°',
      season: 'November - May',
      shelfLife: '4-6 weeks cold storage',
      packaging: '15kg cartons, mesh bags'
    }
  },
  {
    id: 'white-corn',
    name: 'White Corn',
    category: 'Legumes',
    image: 'https://static.readdy.ai/image/375f8353da3743c784fbc166ae5f72ce/1320677e0555ecbfd7d3638c046d66bf.jpeg',
    gallery: [
      'https://readdy.ai/api/search-image?query=Dried%20white%20corn%20kernels%20in%20wooden%20bowl%20on%20rustic%20background%20professional%20food%20photography%20natural%20lighting%20legumes&width=800&height=600&seq=638&orientation=landscape',
      'https://readdy.ai/api/search-image?query=White%20corn%20farm%20in%20Egypt%20harvesting%20scene%20agricultural%20landscape%20professional%20photography%20sunny%20day&width=800&height=600&seq=639&orientation=landscape',
      'https://readdy.ai/api/search-image?query=White%20corn%20in%20burlap%20sacks%20ready%20for%20export%20warehouse%20packaging%20professional%20product%20photography&width=800&height=600&seq=640&orientation=landscape'
    ],
    description: 'Premium Egyptian white corn with excellent quality. High nutritional value and perfect for various food applications.',
    specifications: {
      variety: 'White Dent Corn',
      size: '8-12mm',
      moisture: 'Max 14%',
      season: 'Year-round (dried)',
      shelfLife: '12-24 months dry storage',
      packaging: '25kg PP bags, big bags'
    }
  },
  {
    id: 'white-beans',
    name: 'White Beans',
    category: 'Legumes',
    image: 'https://static.readdy.ai/image/375f8353da3743c784fbc166ae5f72ce/bf2e8595b22f07bebf1a6e4ceaccb6fb.jpeg',
    gallery: [],
    description: 'Premium Egyptian white beans with excellent cooking qualities. High protein content and creamy texture when cooked.',
    specifications: {
      variety: 'Navy, Cannellini, Great Northern',
      size: '8-12mm',
      moisture: 'Max 14%',
      season: 'Year-round (dried)',
      shelfLife: '12-24 months dry storage',
      packaging: '25kg PP bags, big bags'
    }
  }
];

export const categories = ['All', 'Vegetables', 'Fruits', 'Legumes'];